/** @jsxImportSource @emotion/react */
import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import styled from "@emotion/styled";
import { Button } from "../../../components/general/Button/Button";
import { css } from "@emotion/react";
import { OrderStatus } from "../../../types/orderStatus";
import * as Sentry from "@sentry/browser";
import { useTimedQuoteRefetch } from "../../../hooks/useTimedQuoteRefetch";
import { resetOrderAndApprovalState } from "../../../components/ResetButton/ResetButton";

export const OrderErrorButtonsSection: React.FC = () => {
  const { forceRefresh } = useTimedQuoteRefetch();

  return (
    <OrderErrorButtonsContainer>
      <Button
        buttonType="primary"
        textSize={"Large"}
        onClick={() => {
          GlobalStore.update(s => {
            s.orderStatus = OrderStatus.ENTRY;
            s.orderError = undefined;
            s.signedMessage = undefined;
          });
          forceRefresh().catch(err => {
            Sentry.captureException(`Could not force refresh quote after order failed`, {
              extra: { e: err },
            });
          });
        }}
        widthExpand={true}
        buttonCss={css`
          display: flex;
          padding: 19px 18px;
          justify-content: center;
          align-items: center;
          align-self: stretch;
        `}
        text={"Try again"}
      />
      <Button
        buttonType="tertiary"
        onClick={resetOrderAndApprovalState}
        text={"Start from scratch"}
        widthExpand={true}
        buttonCss={css`
          display: flex;
          padding: 19px 18px;
          justify-content: center;
          align-items: center;
          align-self: stretch;
        `}
      />
    </OrderErrorButtonsContainer>
  );
};

const OrderErrorButtonsContainer = styled.div`
  display: flex;
  width: 392px;
  padding: 0 26px 0 26px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
